import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { ActivatedRoute } from '@angular/router';
import { LoadingbarService } from 'src/app/loadingbar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  showText = false;
  showEye = false;
  username = '';
  password = '';
  body = {};
  loginLink: any;
  invalidCredentials = false;
  isLoading = false;

  constructor(
    private svc: StoreService,
    private route: ActivatedRoute,
    private loading: LoadingbarService
  ) {}

   ngOnInit() {

     this.loading.updateLoadingBar(false);
     this.route.queryParams.subscribe(params => {
       let id = params['id'];
       if (id != undefined && id !== '' && id !== null) {

         this.svc.getRedirectLogin(id)
           .subscribe(
             (res) => {
               // if got link
               if (res['data'] !== '') {
                 window.location.replace(this.toCurrentOrigin(res['data']));
               }
             }
           );
       }
     });

    this.addLoaded();
  }
  
  addLoaded(): void {
      setTimeout(() => {
          const elements = document.querySelectorAll('.template-animation');
          elements.forEach(element => {
              element.classList.add('loaded');
          });
      }, 100);
  }
  
  showPassword(): void{
      this.showText = ! this.showText;
      this.showEye = ! this.showEye;
  }

  // On local/dev the API hands back an absolute estore URL (e.g.
  // https://estore-www-dev.fiv5s.dev/sso/login?token=...). Point it back at the
  // host we are served from so the SSO handoff stays on localhost, keeping the
  // path, query string and token untouched.
  private toCurrentOrigin(link: string): string {
    if (environment.production || !link) {
      return link;
    }

    try {
      const url = new URL(link, location.origin);
      url.protocol = location.protocol;
      url.host = location.host;

      return url.toString();
    } catch {
      // Not an absolute URL - leave it for the browser to resolve.
      return link;
    }
  }

  validateAccount(): void {
    this.isLoading = true;
    this.invalidCredentials = false;
    this.body['username'] = this.username;
    this.body['password'] = this.password;
    this.svc.getLoginLink(this.body)
      .subscribe(
        (res) => {
          this.loginLink = this.toCurrentOrigin(res['data']);
          window.location.replace(this.loginLink);
        },
        (error) => {
          this.invalidCredentials = true;
          this.isLoading = false;
        }
      );
  }

  checkEmpty(): boolean {
    if (this.isLoading){
      return true;
    }
    return !this.username || !this.password;
  }
}


